import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getAllPointClouds = () => {
  return progressApi.get(`/PointCloud/GetPointClouds${extractedPath}`);
};

export const getPointCloudbyId = (id: any) => {
  return progressApi.get(`/PointCloud/GetPointCloud${extractedPath}` + `?id=${id}`);
};

export const deletePointCloud = (id: any) => {
  return progressApi.get(`/PointCloud/DeletePointCloud${extractedPath}`);
};

export const modifyPointCloud = (data: any) => {
  return progressApi.post(`/PointCloud/ModifyPointCloud${extractedPath}`, data);
};
